import { v4 as uuidv4 } from 'uuid';
import {
  CookieValueTypes, getCookie, setCookie,
} from 'cookies-next';
import { IncomingMessage, ServerResponse } from 'http';
import { SESSION_ID } from 'constants/browserStorageNames';
import { isServer } from 'utils/misc';

type sessionIdHandlerOptions ={
  expires: Date
  cookieName: string
}

export function createHash() {
  return uuidv4().split('-').join('');
}

export function cookiesIdHandler(
  req?: IncomingMessage,
  res?: ServerResponse,
  sessionOptions: sessionIdHandlerOptions = {
    expires: new Date(),
    cookieName: SESSION_ID,
  },
) {
  let sessionId: CookieValueTypes;

  function getCookieId(name?: string) {
    const { expires } = sessionOptions;
    expires.setFullYear(expires.getFullYear() + 1);
    const options = isServer() ? { req, res } : undefined;

    sessionId = getCookie(name ?? sessionOptions.cookieName, options);
    return sessionId;
  }

  function createCookieId(name?: string) {
    const { expires } = sessionOptions;
    expires.setFullYear(expires.getFullYear() + 1);
    const options = isServer() ? {
      req,
      res,
      domain: process.env.NODE_ENV === 'production' ? '.sympla.com.br' : 'localhost',
      expires,
    } : undefined;

    sessionId = createHash();
    setCookie(name ?? sessionOptions.cookieName, sessionId, options);
    return sessionId;
  }

  function createCookieIfNotExists() {
    const session = getCookieId() as string;
    return session || createCookieId();
  }

  return {
    getSessionId: getCookieId,
    createSessionId: createCookieId,
    createCookieIfNotExists,
  };
}
